<template>
    <div class="w-full px-4 pt-4 pb-0 space-y-2">
        <h3
            class="px-1 text-xs font-semibold tracking-wider text-center text-gray-800 uppercase md:mb-3"
            v-if="heading != ''"
        >
            {{ heading }}
        </h3>
        <primary-navigation-item
            v-for="item in items"
            :key="item.name"
            :item="item"
        />
    </div>
</template>
<script>
export default {
    setup() {

    },
    props: {
        heading: {
            default: '',
            type: String
        },
        items: Object
    }
}
</script>
